import axios, { type AxiosError, type AxiosHeaders, type AxiosResponse } from 'axios';
// import { toast } from 'react-toastify';

import { snakeToCamelCase } from '@/lib/convert-code-style';

export interface CustomAxiosResponse<T = any> extends AxiosResponse<T> {
  message: string | undefined;
  data: any;
  statusCode: number;
}

export interface ApiResponse {
  msg?: string | undefined;
  message: string | undefined;
  data: any;
  statusCode: number;
}

export interface AxiosErr {
  config: any;
  data: any;
  headers: AxiosHeaders;
  request: XMLHttpRequest;
  status: number;
  statusText: string;
  statusCode: number;
}

export const customRes = <T,>(response: AxiosResponse<ApiResponse>): CustomAxiosResponse<T> => {
  const data = response.data?.data;
  let re = null;
  if (data && typeof data[0] === 'object') {
    re = data.map((item: any) => snakeToCamelCase(item));
  } else if (data && Array.isArray(data)) {
    re = data;
  } else if (data && typeof data === 'object') {
    re = snakeToCamelCase(data);
  } else {
    re = data;
  }
  const customResponse: CustomAxiosResponse<T> = {
    ...response,
    data: re, // data === null ? null ? typeof data[0] === 'object' ? data.map((item: any) => snakeToCamelCase(item)) : data.map((item: any) => snakeToCamelCase(item)),
    message: response.data?.message ? response.data?.message : response.data?.msg ? response.data?.msg : '',
    statusCode: response.data?.statusCode,
  };
  if (customResponse.data?.message) {
    delete customResponse.data.message;
  }
  return customResponse;
};

export const axiosErrors = (e: unknown, func: string): Promise<CustomAxiosResponse> => {

  let message = 'Unknown error';
  let statusCode = 0;
  let data = null;
  if (axios.isAxiosError(e)) {
    const axiosError: AxiosError = e;
    data = axiosError.response?.data;
    statusCode = axiosError.response?.status || 400;
    if (axiosError.response) {
      const re: ApiResponse = axiosError.response.data as ApiResponse;
      console.error('Error response:', re.message);
      message = re.message || 'Server responded with an error';
    } else if (axiosError.request) {
      console.error('No response received:', axiosError.request);
      message = 'No response received from server';
    } else {
      console.error('Error setting up the request:', axiosError.message);
      message = axiosError.message;
    }
  } else {
    console.error('Unknown error:', e);
    message = (e as Error)?.message ?? 'Unknown error';
  }

  // 실패 응답을 CustomAxiosResponse 형태로 반환
  return Promise.resolve({
    data,
    status: statusCode,
    statusText: '',
    headers: {} as AxiosHeaders,
    config: {
      headers: new axios.AxiosHeaders(),
    },
    request: undefined,
    message: message,
    statusCode: statusCode,
  });
};
